import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import { SSMProductStatus } from '../../../../../models'

export const ChipStatusWrapper = styled(Box)<{ status: SSMProductStatus }>`
  width: fit-content;
  height: 28px;
  padding: 4px 16px;
  text-align: center;
  font-family: Quicksand, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.1px;
  border-radius: 6px;

  ${({ status }) =>
    status === SSMProductStatus.Ongoing &&
    `
      background: #DEBDD9;
      color: #292128;
  `};

  ${({ status }) =>
    status === SSMProductStatus.Upcoming &&
    `
      background: #3754FC;
      color: #E9E0E4;
  `};

  ${({ status }) =>
    status === SSMProductStatus.Ended &&
    `
      background: #6C5B67;
      color: #E9E0E4;

      html[data-theme='light'] & {
        background: #ededf0;
        color: #18181f;
      }
  `};
`
